import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { api } from '../api.js';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api('/api/auth/me').then((data) => setUser(data.user)).catch(() => setUser(null)).finally(() => setLoading(false)); }, []);
  useEffect(() => {
    let hiddenAt = 0;
    const restoreSessionAndMedia = async (event) => {
      if (event?.type === 'pageshow' && !event.persisted) return;
      try {
        const data = await api('/api/auth/me');
        setUser(data.user);
      } catch (error) {
        if (error.status === 401) setUser(null);
      } finally {
        window.dispatchEvent(new Event('biblioteca:media-restore'));
      }
    };
    const handleVisibility = () => {
      if (document.visibilityState === 'hidden') hiddenAt = Date.now();
      else if (hiddenAt && Date.now() - hiddenAt > 10_000) restoreSessionAndMedia();
    };
    window.addEventListener('pageshow', restoreSessionAndMedia);
    window.addEventListener('popstate', restoreSessionAndMedia);
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      window.removeEventListener('pageshow', restoreSessionAndMedia);
      window.removeEventListener('popstate', restoreSessionAndMedia);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);
  const logout = async () => { await api('/api/auth/logout', { method: 'POST' }, false).catch(() => {}); setUser(null); };
  const value = useMemo(() => ({ user, setUser, loading, logout }), [user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function ProtectedRoute({ children, admin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="auth-loading"><span className="spinner"/>Se pregătește biblioteca…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (admin && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}
